import { memo } from 'react';
import DatePicker from '../../DatePicker/DatePicker.jsx';
import FilterSlideoutSection from '../FilterSlideoutSection.jsx';
import { clearSection, getSectionActiveCount } from '../filterSlideout.utils.js';

const DATE_RANGE_PICKER_TRIGGER_CLASS = [
  '!h-8 !min-h-8 !flex-row-reverse !justify-end !gap-1',
  '!rounded-lg !border-[0.5px] !border-[#5C5C5C] !bg-white !px-4 !py-1',
  'hover:!border-accent/50 focus:!border-accent/50 focus-visible:!border-accent/50',
  'dark:!border-edge dark:!bg-surface',
  '!text-sm !font-medium !leading-5 !text-content',
  '[&>span]:min-w-0 [&>span]:truncate [&>span]:!leading-5',
  '[&>svg]:!size-4 [&>svg]:!text-[#5C5C5C] dark:[&>svg]:!text-content-muted',
].join(' ');

const DateRangeSection = ({ section }) => {
  const activeCount = getSectionActiveCount(section);
  const value = section.value ?? {};

  const handleChange = (key, next) => {
    section.onChange?.({ ...value, [key]: next });
  };

  return (
    <FilterSlideoutSection
      title={section.title}
      defaultExpanded={section.defaultExpanded ?? true}
      disabled={section.disabled}
      activeCount={activeCount}
      onClear={() => clearSection(section)}
    >
      <div className="grid grid-cols-2 gap-3">
        <div className="min-w-0">
          <span className="sr-only">{section.fromLabel ?? 'From'}</span>
          <DatePicker
            value={value.from ?? ''}
            onChange={(next) => handleChange('from', next)}
            disabled={section.disabled}
            placeholder={section.fromLabel ?? 'From'}
            size="xs"
            locale={section.locale}
            className="min-w-0"
            triggerClassName={DATE_RANGE_PICKER_TRIGGER_CLASS}
            labels={{ openPicker: section.fromLabel ?? 'From' }}
          />
        </div>
        <div className="min-w-0">
          <span className="sr-only">{section.toLabel ?? 'To'}</span>
          <DatePicker
            value={value.to ?? ''}
            onChange={(next) => handleChange('to', next)}
            disabled={section.disabled}
            placeholder={section.toLabel ?? 'To'}
            size="xs"
            locale={section.locale}
            className="min-w-0"
            triggerClassName={DATE_RANGE_PICKER_TRIGGER_CLASS}
            labels={{ openPicker: section.toLabel ?? 'To' }}
          />
        </div>
      </div>
    </FilterSlideoutSection>
  );
};

export default memo(DateRangeSection);
